import { render, staticRenderFns } from "./ArticlePartViewer.vue?vue&type=template&id=188493d9&scoped=true&"
import script from "./ArticlePartViewer.vue?vue&type=script&lang=js&"
export * from "./ArticlePartViewer.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePartViewer.vue?vue&type=style&index=0&id=188493d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188493d9",
  null
  
)

export default component.exports